import { useState, useEffect } from "react";
import convert from "color-convert";
import { defaultClientConfig } from "clientConfig";
import { Capacitor } from "@capacitor/core";
const lightenColor = (color, factor) => {
    const result = convert.hex.hsl(color);
    const lightAmount = factor * 100;
    result[2] = Math.min(Math.max(lightAmount + result[2], 0), 100);
    return `#${convert.hsl.hex(result)}`;
};
const applyThemeAndConfiguration = (data) => {
    const { styling, configuration } = data;
    if (styling) {
        const lightenAmount = 5;
        const steps = 100 / lightenAmount;
        Object.keys(styling).forEach((key) => {
            document.documentElement.style.setProperty(`--${key}`, styling[key]);
            for (let i = 1; i <= steps; i++) {
                document.documentElement.style.setProperty(`--${key}_darken_${i * lightenAmount}`, lightenColor(styling[key], -i / steps));
                document.documentElement.style.setProperty(`--${key}_lighten_${i * lightenAmount}`, lightenColor(styling[key], i / steps));
            }
        });
    }
    if (configuration) {
        const windowConfig = window &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.__INTERFI__;
        const deviceAssetsBaseUri = windowConfig.deviceAssetsBaseUri;
        const capitalApiBaseUri = windowConfig.capitalApiBaseUri;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const loadedWindowConfig = (window.__INTERFI__ = {
            ...defaultClientConfig,
            ...configuration,
        });
        loadedWindowConfig.deviceAssetsBaseUri = deviceAssetsBaseUri;
        loadedWindowConfig.capitalApiBaseUri = capitalApiBaseUri;
    }
};
const Platform = Capacitor.getPlatform();
const CapitalThemeLoader = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        if (process.env.FORTIS_USE_JSON_THEMING === "0") {
            setIsLoading(false);
            return;
        }
        let isActive = true;
        let themePath = "/client/theme.json";
        if (Platform !== "web") {
            const windowConfig = window &&
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                window.__INTERFI__;
            themePath = `${windowConfig.deviceAssetsBaseUri}${themePath}`;
        }
        fetch(themePath)
            .then((response) => response.json())
            .then((data) => {
            if (isActive) {
                applyThemeAndConfiguration(data);
                setIsLoading(false);
            }
        })
            .catch((error) => console.log(error.message));
        return () => {
            isActive = false;
        };
    }, []);
    if (isLoading) {
        return null;
    }
    return children;
};
export default CapitalThemeLoader;
